import { Component, HostListener, OnInit, ViewChild, ElementRef, Renderer2, Inject, PLATFORM_ID, OnDestroy } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { debounceTime, Observable } from 'rxjs';
import { SignInService } from '../../../shared/services/sign-in.service';
import { UtilsService } from '../../../shared/services/utils.service';
// import { SocialAuthService } from "@abacritt/angularx-social-login";
import { NavigationEnd, Router, Event as NavigationEvent, RouterModule } from '@angular/router';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { CommonModule, DecimalPipe, isPlatformBrowser } from '@angular/common';
import { HttpService } from '../../../shared/services/http.service';
import { SchemaService } from '../../../shared/services/schema.service';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/internal/Subscription';
import { JsonDataService } from '../../../shared/services/json-data.service';
import { InbtHomepageService } from '../../../shared/services/inbt-homepage.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { ProfileSidebarComponent } from "../../../shared/components/profile-sidebar/profile-sidebar.component";
import { ResponsiveUIService } from '../../../services/responsive-ui.service';
import { CartService } from '../../../shared/services/cart.service';
import { SocialAuthService } from '@abacritt/angularx-social-login';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule, MatSidenavModule, MatAutocompleteTrigger, MatExpansionModule, MatAutocompleteModule, ReactiveFormsModule, ProfileSidebarComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {
  @ViewChild('sidenav') sidenav!: MatSidenav;
  @ViewChild(MatAutocompleteTrigger) autocomplete!: MatAutocompleteTrigger;
  @ViewChild('customerCareInfo') el!: ElementRef;
  sub: Subscription = new Subscription()
  environment: any = environment;
  myControl = new FormControl();
  sidenavOpen: boolean = false;
  pinCode: string = '';
  showSearchBar: boolean = true;
  removeSearch: boolean = true
  isLogIn: boolean = false;
  recentlySearchList: any = [];
  navBarStaticData: any = [];
  category!: string;
  process = 0;
  scrollLeft: boolean = false;
  showDropDownList: boolean = false;
  menuList: any = [];
  event$: any;
  hideSearch: boolean = false;
  phoneNumber: any = '+91-8906008008';
  customerCareNumber: any = '+91-9999933039';
  showContactInfo: boolean = true;
  categoryarr: any[] = [];
  seriesarr: any[] = [];
  searchResults: any[] = [];
  deviceStatus: any
  constructor(public utils: UtilsService, @Inject(PLATFORM_ID) private platformId: Object, public http: HttpService, public analyticsService: AnalyticsService, private _decimalPipe: DecimalPipe, private renderer: Renderer2,
    private SigninService: SignInService, private authService: SocialAuthService, private router: Router, public service: CartService,
    private schemaService: SchemaService, private jsonDataService: JsonDataService, private httpSvc: HttpService, private responsiveService: ResponsiveUIService
  ) {
    this.responsiveService.getDeviceStatus().subscribe((res: any) => {
      if (res) {
        this.deviceStatus = res;
      } else { }
    })
    this.utils.showLoading();
    if (this.utils.screenSizeObj.width >= 768) {
      this.getMenuList();
    } else { }
    // this.getScreenWidth()
    this.sub.add(this.event$ = this.router.events
      .subscribe(
        (event: NavigationEvent) => {
          if (event instanceof NavigationEnd) {
            this.myControl.setValue('');
            if (event.url == '/search') {
              this.hideSearch = true;
            }
            else {
              this.hideSearch = false;
            }
          }
        }));

    this.sub.add(utils.menuList.subscribe((data: any) => {
      this.menuList = []
      this.menuList = data;
    }))

  }

  @HostListener('window:scroll', ['$event'])
  scrollHandler(event: any) {
    if (document.documentElement.scrollTop >= 49 && this.showSearchBar) {
      this.showSearchBar = false;
      this.myControl.setValue('');
      if (this.autocomplete)
        this.autocomplete.closePanel();
    }
    else if (document.documentElement.scrollTop < 49 && !this.showSearchBar) {
      this.showSearchBar = true;
    }
    if (document.documentElement.scrollTop > 100 && this.showContactInfo) {
      this.showContactInfo = false;
    } else if (document.documentElement.scrollTop <= 100 && !this.showContactInfo) {
      this.showContactInfo = true;
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.resizeHandler(event);
    this.getScreenWidth();
  }

  @HostListener('window:click', ['$event'])
  onWindowClick(event: any) {
    this.windowClick(event);
  }

  @HostListener('window:load', ['$event'])
  onWindowLoad(event: any) {
    this.getScreenWidth();
  }

  resizeHandler(event: any) {
    if (this.sidenav && this.sidenav.opened) {
      this.navBarHandler(false);
    }
  }

  windowClick(event: any) {
    let id = event.target.getAttribute("id");
    if (id != 'userImgHover') {
      this.showDropDownList = false;
    }
  }

  getScreenWidth() {
    if(isPlatformBrowser(this.platformId)) {  
      this.setViewSize(window.innerWidth, window.innerHeight);
    }
  }



  setViewSize(width: any, height: any) {
    this.utils.screenSizeObj.width = width;
    this.utils.screenSizeObj.height = height;
    switch (true) {
      case width < 576:
        this.utils.screenSizeObj.type = 'mobile';
        break;
      case width < 768:
        this.utils.screenSizeObj.type = 'tab';
        break;
      case width >= 768:
        this.utils.screenSizeObj.type = 'desktop';
        // this.getMenuList();
        break;
      default:
        this.utils.screenSizeObj.type = 'not defined';
        break;
    }
  }


  ngOnInit(): void {
    this.isLogIn = this.SigninService.getIsAuth();
    this.sub.add(this.SigninService.getAuthStatusListener()
      .subscribe((response: any) => {
        this.isLogIn = response
      }))

    this.sub.add(this.router.events.subscribe(
      (event: any) => {
        if (event instanceof NavigationEnd) {

          if (this.router.url == '/search') {
            this.removeSearch = false;
          }

          else {
            this.removeSearch = true;
          }
        }
      }
    ));
  }

  getJsonData() {
    this.sub.add(this.jsonDataService.getnavBarStaticDataJsonData().subscribe({
      next: (res: any) => {
        this.navBarStaticData = res;

      },
      error: (err: any) => {
      }
    }));
    this.utils.showHeaderFooter.next(true);
  }

  getMenuList() {

    let staticData = {
      "brandCategoriesMenus": [
        {
          "landingPageGuid": "3335eb72-a049-406f-b60e-a72542a784f4",
          "guid": "d7544be8-a24c-4c68-b1e3-210adb5946cf",
          "category": "Power Solution",
          "categoryType": "INBT",
          "brandSubCategoriesMenus": [
            {
              "landingPageGuid": "537e14ea-8676-454a-b17f-8dddfde4fe08",
              "guid": "46c05e08-98da-4fc4-8535-87a7a2d53325",
              "subCategory": "Home Inverters",
              "series": [
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "61A6CEAD-5A89-4767-9D01-F1B1137844CA",
                  "series": "EVO D",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "FCE87A66-65F9-4DF3-93D5-8FA4B76A19BF",
                  "series": "EVO S",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "963f3c3a-7626-4adf-b532-4191c87348a7",
                  "guid": "f5e2dada-f7fe-4663-b031-77bdc52376c0",
                  "series": "Zelio Series",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "23ee4b6d-8573-4d77-bc78-9a3d0f285abb",
                  "guid": "afc51f4b-5ded-4a14-a513-646b46a346b5",
                  "series": "Li-ON Series",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "060a1047-80aa-40ee-a430-a4555983e508",
                  "guid": "7ff47fc4-d679-45aa-94ad-44e3d6715895",
                  "series": "Icon Series",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "42dde0f0-a160-40f6-8a94-114402c0c1b7",
                  "guid": "26b1bccd-eddd-4de3-973e-eadfb1574b39",
                  "series": "Optimus Series",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "9cb9e4cf-57fe-4497-b8fc-2c1e5b0c13e2",
                  "guid": "1f3a7f05-b12b-4245-b885-4116ed09dc8a",
                  "series": "Shakti Charge Inverters",
                  "subSubCatId": 0
                },
                // {
                //   "landingPageGuid": "93f53654-4d4c-4508-8b46-55fc78d3019d",
                //   "guid": "78b04b3a-387e-4df2-98b4-fbfdde890a9f",
                //   "series": "Eco Watt Rapid",
                //   "subSubCatId": 0
                // },
                {
                  "landingPageGuid": "c3c4bd41-02c4-4b59-8219-adccb2fb784b",
                  "guid": "c2ae316c-d815-4d49-9ec3-64e86a9875a9",
                  "series": "Eco Watt NEO",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "6bec5bfb-fe6e-467d-b37b-5214b2d9a4fd",
                  "guid": "60b6233f-3e6e-4467-a460-ec5ec0fec1c2",
                  "series": "Eco Volt NEO",
                  "subSubCatId": 0
                }
              ],
              "brandSubSubCategoriesMenu": []
            },
            {
              "landingPageGuid": "d39d8f12-5d86-4a65-ad39-596d4bb0c7d8",
              "guid": "b6410047-ceaa-431b-bb9b-8ef60961a9dd",
              "subCategory": "High Capacity Inverters",
              "series": [
                {
                  "landingPageGuid": "59a752c3-3e55-4df1-a90b-5d990105f210",
                  "guid": "dd5ec34e-336c-4751-9943-2216916d8306",
                  "series": "iCruze",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "ddcd4b92-a878-4fd8-ab31-7b9ede7e69d7",
                  "guid": "c274fb3c-b9aa-4f57-9f42-951d79eae5b5",
                  "series": "Optimus HKVA",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "f4773d6b-a5d0-4e4f-84a7-7afb4e98feb9",
                  "guid": "99ead33b-aaf5-4f52-9b70-1c800eadfdc2",
                  "series": "Power Pro",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "1422bc28-d6dc-4218-8e08-66a238aa8242",
                  "series": "LIFTVERTER",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "d886f456-acb8-431c-a89e-f35d8ef7f47e",
                  "series": "Optimus 3 Phase",
                  "subSubCatId": 0
                }
              ],
              "brandSubSubCategoriesMenu": []
            },
            {
              "landingPageGuid": "52b02d1b-63d6-4bb9-9f40-9ea66f073120",
              "guid": "d276959d-e16a-4d4f-8d01-1c84257c4817",
              "subCategory": "Batteries",
              "series": [
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "5d1edb07-16e1-4e28-a6d5-8a2855f31ad9",
                  "series": "AmpBox",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "82409066-d313-414e-8874-c5da691876f6",
                  "guid": "0e86af51-3c48-4750-afa0-362d7cda8fd9",
                  "series": "Red Charge Pro",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "d3ead40d-b1fa-46eb-af8e-f10e4ed41566",
                  "guid": "014b3430-99be-4a50-8d16-becc427f054a",
                  "series": "Inverlast",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "f0a423c7-e35d-4f7f-9c60-b7f2ed021a7f",
                  "guid": "608a007d-584a-4304-a4ec-442ccf4e5f10",
                  "series": "Shakti Charge",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "093d52b5-520d-4f6a-9068-d4d94b413d9c",
                  "guid": "64dbc9a1-6299-4cd1-9fba-9e70ebc6e614",
                  "series": "Neo Charge",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "3638acd9-7da6-483f-8cc4-e0bdf52d15b9",
                  "guid": "a57fb3e2-c42d-4e5a-b29f-234b39251ae3",
                  "series": "Power Charge",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "f7f53198-0d76-4cfd-9966-b3e7d1205b9f",
                  "guid": "81253235-1077-4954-bc95-05f85530e4a4",
                  "series": "Eco Charge",
                  "subSubCatId": 0
                },
                // {
                //   "landingPageGuid": "f5cb4756-40ac-4ac1-820c-690eb0bd3b56",
                //   "guid": "52f5f6d0-c716-4721-89b8-4735b4d1b3ec",
                //   "series": "InverGel",
                //   "subSubCatId": 0
                // },
                // {
                //   "landingPageGuid": "a4effb80-c572-45a6-a20b-1ca19d85b58f",
                //   "guid": "10e8d2d3-b8aa-4df2-a369-0a1c286ff2b2",
                //   "series": "Inverlast XL",
                //   "subSubCatId": 0
                // },
                {
                  "landingPageGuid": "5f0da67f-dec3-4490-8f44-cec3528a0b85",
                  "guid": "5d9b4a14-1d2d-455e-a4f9-fdb7e7eeb28e",
                  "series": "Lifemax",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "d490c2fa-91f8-4a6d-9442-c478194df6d7",
                  "guid": "8b437ed1-34eb-423c-9b14-c11624737ce5",
                  "series": "Extra Charge",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "151e0a33-22ec-41c6-b554-c0b3fab5cf06",
                  "guid": "346bc353-75f1-4af4-869c-bf0644cb20ae",
                  "series": "Ultra Charge",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "d55eba4e-c2b6-4a2d-b941-b3a377e8466c",
                  "series": "AmpPower",
                  "subSubCatId": 0
                },
                // {
                //   "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                //   "guid": "ec5b2e7a-98de-4fb2-acd2-7bc794b887a2",
                //   "series": "Boost Charge",
                //   "subSubCatId": 0
                // }
              ],
              "brandSubSubCategoriesMenu": []
            },
            {
              "landingPageGuid": "440b1aa5-bb3b-449a-afd4-83cd2da3e033",
              "guid": "f878ddb4-7d02-4251-8cd3-cd594819eb0b",
              "subCategory": "Accessory",
              "series": [
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "6078e1e4-9f17-4fce-a543-b44334110311",
                  "series": "ToughX Trolley",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "6e9f31f1-5ca5-44d4-891e-8a6f6b64cf77",
                  "series": "Connect Wi-fi Dongle",
                  "subSubCatId": 0
                }
              ],
              "brandSubSubCategoriesMenu": []
            }
          ],
          "activeFeatureIconFile": "https://lumuatsta.blob.core.windows.net/prodcontainer/Images/e3d2ac2f-a20b-4c2f-964c-1bec69dd46da_power-svgrepo-com.svg",
          "featureAltTag": "Power Solution | Luminous",
          "inActiveFeatureIconFile": "https://lumuatsta.blob.core.windows.net/prodcontainer/Images/889c7f3f-d496-4a97-9761-762c0cd7eaee_power-svgrepo-com.svg"
        },
        {
          "landingPageGuid": "e7b59670-5010-4829-9aef-972a81e42d03",
          "guid": "ddc5efdf-f6d5-45d3-837b-fea6b17e2293",
          "category": "Solar Solutions",
          "categoryType": "Solar",
          "brandSubCategoriesMenus": [
            {
              "landingPageGuid": "2d025318-93ce-4d2f-9c40-380985a24303",
              "guid": "31e92abe-ed67-4127-8ef5-6b1fecd809c9",
              "subCategory": "Solar Financing",
              // "series": [
              //   {
              //     "landingPageGuid": "00000000-0000-0000-0000-000000000000",
              //     "guid": "1c2d1ef2-4eb3-4780-8766-c01a4cad6fcb",
              //     "series": "Polycrystalline Solar Panels",
              //     "subSubCatId": 0
              //   },
              //   {
              //     "landingPageGuid": "00000000-0000-0000-0000-000000000000",
              //     "guid": "2d326728-8bd4-4a5f-9ab1-e56f26b441a0",
              //     "series": "Mono PERC Half Cut Solar Panels",
              //     "subSubCatId": 0
              //   }
              // ],
              "brandSubSubCategoriesMenu": []
            },
            {
              "landingPageGuid": "2d025318-93ce-4d2f-9c40-380985a24303",
              "guid": "31e92abe-ed67-4127-8ef5-6b1fecd809c9",
              "subCategory": "Solar Panels",
              "series": [
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "1c2d1ef2-4eb3-4780-8766-c01a4cad6fcb",
                  "series": "Polycrystalline Solar Panels",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "2d326728-8bd4-4a5f-9ab1-e56f26b441a0",
                  "series": "Mono PERC Half Cut Solar Panels",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "1a43097a-528c-4b20-8ddf-99c14feca0b0",
                  "series": "Topcon Solar Panels",
                  "subSubCatId": 0
                }
              ],
              "brandSubSubCategoriesMenu": []
            },
            {
              "landingPageGuid": "983d1f23-b9ca-4bab-9ffe-bf59da84b83e",
              "guid": "5c323c18-99ab-4a2a-9f5c-56c0a8a7de86",
              "subCategory": "Solar Inverters",
              "series": [
                // {
                //   "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                //   "guid": "294af29b-8218-4ce6-b829-c5fa5d1afc50",
                //   "series": "NXT+ Series",
                //   "subSubCatId": 0
                // }
              ],
              "brandSubSubCategoriesMenu": [
                {
                  "brandSubSubCategoryGuidId": "a39253fc-d219-4e5c-b96f-28021aa6c806",
                  "landingPageGuidId": "75152209-d332-4216-b655-3269bbff3fa3",
                  "brandSubSubCategoryId": 1,
                  "name": "For Homes & Shop",
                  "series": [
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "db4f317d-43ab-4d5d-9966-13858d88e94a",
                      "series": "NXG Series",
                      "subSubCatId": 1
                    },
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "52584ff8-a7fc-4e21-bbc7-95e6027d778a",
                      "series": "NXG PRO",
                      "subSubCatId": 1
                    },
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "69e4317a-0c11-489e-98ac-0d456284dc90",
                      "series": "NXI Grid Tie Inverter (1kW to 5kW)",
                      "subSubCatId": 1
                    }
                  ]
                },
                {
                  "brandSubSubCategoryGuidId": "7ddcf993-ddb4-41ad-88ea-4b13fb2bd852",
                  "landingPageGuidId": "3da44d74-4872-4503-9ed0-d4318635c45f",
                  "brandSubSubCategoryId": 2,
                  "name": "For Farmhouses, Offices & Retail",
                  "series": [
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "cb30e47e-ae78-4031-b3a4-8bc2c4a34343",
                      "series": "Solarverter Series",
                      "subSubCatId": 2
                    },
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "55e44fb6-2d28-4095-a8d1-13b52c5bfd94",
                      "series": "Solarverter PRO (2 KVA to 5 KVA)",
                      "subSubCatId": 2
                    },
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "ae297b64-b7e4-461a-8f52-4e70352d8a11",
                      "series": "Hybrid TX series",
                      "subSubCatId": 2
                    },
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "d5f0b19f-eea4-4be4-b572-999a3e4bda03",
                      "series": "NXI Grid Tie Inverter (6kW to 20kW)",
                      "subSubCatId": 2
                    },
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "1cc1a0e0-8327-431d-802a-0bf700c5ca5c",
                      "series": "NXP Series",
                      "subSubCatId": 2
                    }
                  ]
                },
                {
                  "brandSubSubCategoryGuidId": "28ae3c14-7513-4c3f-9ad1-5a6b80930a41",
                  "landingPageGuidId": "3a1b11b4-ef58-4c91-99d3-1cf721555a8b",
                  "brandSubSubCategoryId": 3,
                  "name": "For Commercial & Institutions",
                  "series": [
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "bbfc57e7-2302-44bb-84a0-5228183afec7",
                      "series": "NXI Grid Tie Inverter (25kW to 100kW)",
                      "subSubCatId": 3
                    },
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "74df24da-aafc-46c3-9db2-a1809d5c37d4",
                      "series": "Solarverter PRO (6 KVA to 10 KVA)",
                      "subSubCatId": 3
                    },
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "4a5443f2-392f-4e3b-bc19-26c358ce5137",
                      "series": "3 Phase Solar Hybrid TX Series",
                      "subSubCatId": 3
                    }
                  ]
                }
              ]
            },
            {
              "landingPageGuid": "abd8af03-77d1-4f9a-ab2e-20fab598dd3f",
              "guid": "6668241a-d9c1-4595-9139-f54d0738f0ac",
              "subCategory": "Solar Charge Controllers & Retrofits",
              "series": [
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "c6fa7159-452e-4e9c-a8a9-1a49132b3c1d",
                  "series": "Solar Charge Controllers",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "f0edf99c-5519-4c3c-b69c-64e6ddb2e5fa",
                  "series": "Shine Retrofits",
                  "subSubCatId": 0
                }
              ],
              "brandSubSubCategoriesMenu": []
            },
            {
              "landingPageGuid": "410815e1-200c-4d84-ab4e-99c4a31e04be",
              "guid": "8c82a3ec-431e-4a15-bdd1-7c9e577c61d4",
              "subCategory": "Solar Batteries",
              "series": [
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "c627d4e8-ef3e-4b87-a3cd-f696077b3f62",
                  "series": "L Series Solar Batteries",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "e46cc6f1-574d-4fb9-bb0e-b18d7c234c3d",
                  "series": "H Series Solar Batteries",
                  "subSubCatId": 0
                }
              ],
              "brandSubSubCategoriesMenu": []
            },
            {
              "landingPageGuid": "ff703276-ada4-4455-ac78-0031946e3434",
              "guid": "529b44a6-775c-401a-b4b7-ea885cd7d556",
              "subCategory": "Solar Packages",
              "series": [
                {
                  "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                  "guid": "5a2c4d5d-40c3-412d-aef6-2f283320f3c6",
                  "series": "Solar Systems with Battery (PWM) | Off Grid Solar Solutions",
                  "subSubCatId": 0
                },
                {
                  "landingPageGuid": "98f89faf-b4d0-4b8e-b740-ca9f6a735987",
                  "guid": "7bab47c5-5d00-43da-99ed-844328be782d",
                  "series": "Hybrid Solar Solutions",
                  "subSubCatId": 0
                }
              ],
              "brandSubSubCategoriesMenu": []
            }
          ],
          "activeFeatureIconFile": "https://lumuatsta.blob.core.windows.net/prodcontainer/Images/0ed936de-80b5-4fed-87a7-861e1ff4c1ee_PanelIcon.svg",
          "featureAltTag": "Solar Solutions | Luminous",
          "inActiveFeatureIconFile": "https://lumuatsta.blob.core.windows.net/prodcontainer/Images/8e0c9791-6ff8-4061-85a0-b1bf98b1db0a_PanelIcon.svg"
        },
        {
          "landingPageGuid": "d36d5ab1-eb1d-4462-80d4-6db9d17d1b21",
          "guid": "ff5f21ef-1211-4c47-85d9-2fd9dba8288e",
          "category": "Mobility Solution",
          "categoryType": "INBT",
          "brandSubCategoriesMenus": [
            {
              "landingPageGuid": "314821b0-3839-47dc-b0c3-10e35c9b78ed",
              "guid": "66593878-40d5-40b9-993e-09ba10b07b66",
              "subCategory": "E-Rickshaw Battery",
              "brandSubSubCategoriesMenu": [
                {
                  "brandSubSubCategoryGuidId": "a39233fc-d219-4e5c-b96f-28021ao6c806",
                  "landingPageGuidId": "3da44d74-4872-4503-9ed0-d4318635c45f",
                  "brandSubSubCategoryId": 1,
                  "name": "Lead Acid",
                  "series": [
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "585d3e52-8f9b-47ab-a44b-959140343800",
                      "series": "Rick Power",
                      "subSubCatId": 1
                    }
                  ]
                },
                {
                  "brandSubSubCategoryGuidId": "7ddku993-ddb4-41ad-88ea-4b13jh2bb852",
                  "landingPageGuidId": "4e5b6c7d-8910-4a2b-b3c4-e5f6d7a8b9c0",
                  "brandSubSubCategoryId": 2,
                  "name": "Li-on",
                  "series": [
                    {
                      "landingPageGuid": "00000000-0000-0000-0000-000000000000",
                      "guid": "5bf84e8e-b0d7-460f-85d1-2f10e36adfe3",
                      "series": "Cruze",
                      "subSubCatId": 2
                    }
                  ]
                }
              ]
            }
          ],
          "activeFeatureIconFile": "https://lumuatsta.blob.core.windows.net/prodcontainer/Images/e04c3f77-6d73-4a8b-a20c-e2acc1cff6ef_889c7f3f-d496-4a97-9761-762c0cd7eaee_power-svgrepo-com.svg",
          "featureAltTag": "Mobility Solutions | Luminous",
          "inActiveFeatureIconFile": "https://lumuatsta.blob.core.windows.net/prodcontainer/Images/049e4972-33d1-4c7a-a4b8-d61f94959adf_889c7f3f-d496-4a97-9761-762c0cd7eaee_power-svgrepo-com.svg"
        }
      ],
      "success": true
    };

    const obj: {
      landingPageGuid: string;
      guid: string;
      category: string;
      categoryType: string;
      brandSubCategoriesMenus: {
        landingPageGuid: string;
        guid: string;
        subCategory: string;
        series: {
          landingPageGuid: string;
          guid: string;
          series: string;
          subSubCatId: number;
        }[];
        brandSubSubCategoriesMenu: any[];
      }[];
      activeFeatureIconFile: string;
      inActiveFeatureIconFile: string;
      featureAltTag: string;
    } = {
      landingPageGuid: "some-landing-page-guid", // Provide the actual landing page GUID
      guid: "some-guid", // Provide the actual GUID
      category: "E-Shop",
      categoryType: "some-category-type", // Provide the actual category type
      brandSubCategoriesMenus: [],
      activeFeatureIconFile: environment?.blobUrl + '/assets/icons/eshop.svg', // Provide the actual active feature icon file path
      inActiveFeatureIconFile: environment?.blobUrl + '/assets/icons/eshop.svg',
      featureAltTag: 'eshop'
    };


    const obj2: {
      landingPageGuid: string;
      guid: string;
      category: string;
      categoryType: string;
      brandSubCategoriesMenus: {
        landingPageGuid: string;
        guid: string;
        subCategory: string;
        series: {
          landingPageGuid: string;
          guid: string;
          series: string;
          subSubCatId: number;
        }[];
        brandSubSubCategoriesMenu: any[];
      }[];
      activeFeatureIconFile: string;
      inActiveFeatureIconFile: string;
      featureAltTag: string;
    } = {
      landingPageGuid: "some-landing-page-guid", // Provide the actual landing page GUID
      guid: "some-guid", // Provide the actual GUID
      category: "Store Locator",
      categoryType: "some-category-type", // Provide the actual category type
      brandSubCategoriesMenus: [],
      activeFeatureIconFile: environment?.blobUrl + '/assets/icons/eshop.svg', // Provide the actual file path
      inActiveFeatureIconFile: environment?.blobUrl + '/assets/icons/eshop.svg',
      featureAltTag: 'storelocator'
    };


    // Process the static data instead of API response
    let res: any = staticData;

    if (res.brandCategoriesMenus) {
      // Alphabetical rearrange the brandSubCategories
      res.brandCategoriesMenus.forEach((element: any) => {
        element.brandSubCategoriesMenus.sort((a: any, b: any) => {
          if (a.subCategory.toLowerCase() < b.subCategory.toLowerCase()) { return -1; }
          if (a.subCategory.toLowerCase() > b.subCategory.toLowerCase()) { return 1; }
          return 0;
        });
      });

      res.brandCategoriesMenus.push(obj, obj2);
      this.utils.menuList.next(res.brandCategoriesMenus);

      this.categoryarr = res.brandCategoriesMenus;
      this.categoryarr.forEach(category => {
        category.brandSubCategoriesMenus.forEach((subCategory: { series: string | any[]; }) => {
          if (subCategory.series && subCategory.series.length > 0) {
            this.seriesarr.push(...subCategory.series);
          }
        });
      });
      setTimeout(() => {
        this.rearrangeSeries(1, 4, 2, 0);
      }, 500)

      // this.rearrangeSeries(0, 1, 5, 0);
      this.rearrangeSeries(0, 1, 10, 2);
      this.rearrangeSeries(0, 1, 2, 1);
      // this.rearrangeSeries(0, 1, 6, 1);
      // this.rearrangeSeries(0, 1, 2, 0);
      this.rearrangeBrandSubCategories(2, 5, 1)
    }
  }


  rearrangeBrandSubCategories(currentIndex: number, newIndex: number, categoryIndex: number) {
    if (categoryIndex >= 0 && categoryIndex < this.categoryarr.length) {
      const category = this.categoryarr[categoryIndex];
      const brandSubCategoriesMenus = category.brandSubCategoriesMenus;
      if (brandSubCategoriesMenus && brandSubCategoriesMenus.length > 0 &&
        currentIndex >= 0 && currentIndex < brandSubCategoriesMenus.length &&
        newIndex >= 0 && newIndex < brandSubCategoriesMenus.length) {
        const [removedElement] = brandSubCategoriesMenus.splice(currentIndex, 1);
        brandSubCategoriesMenus.splice(newIndex, 0, removedElement);
      } else {
      }
    } else {
    }
  }
  rearrangeSeries(categoryIndex: number, subCategoryIndex: number, currentIndex: number, newIndex: number) {
    if (categoryIndex >= 0 && categoryIndex < this.categoryarr.length) {
      const category = this.categoryarr[categoryIndex];
      if (subCategoryIndex >= 0 && subCategoryIndex < category.brandSubCategoriesMenus.length) {
        const subCategory = category.brandSubCategoriesMenus[subCategoryIndex];
        const series = subCategory.series;
        if (series && series.length > 0 &&
          currentIndex >= 0 && currentIndex < series.length &&
          newIndex >= 0 && newIndex < series.length) {
          const [removedElement] = series.splice(currentIndex, 1);
          series.splice(newIndex, 0, removedElement);
        } else {
        }
      } else {
      }
    } else {
    }
  }
  openSearchBar(flag: boolean) {
    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }
    this.showSearchBar = flag;
  }

  clearSearch() {
    this.myControl.setValue('');
    this.searchResults = [];
  }

  navBarHandler(flag: boolean) {
    if (this.sidenav) {
      this.sidenav.toggle();
      this.sidenavOpen = flag;
      if (flag) {
        if (isPlatformBrowser(this.platformId)) {
          window.scrollTo(0, 0);
          this.getJsonData()
          this.getMenuList()
        }
        document.body.style.overflow = 'hidden';
      }
      else
        document.body.style.overflow = 'visible';
      this.resetAllNavBarNavigation();
    }
  }
  onEnter(event: any) {
    if (event && (event.keyCode == 13 || event.which == 13 || event.type == 'submit')) {
      if (this.myControl.value.length > 2) {
        this.utils.inputVal.next(this.myControl.value);
        this.router.navigate(['/search'])
      }
    }
  }

  onSearchClick(onClick?: boolean) {
    if (this.myControl.value.length > 2 || onClick) {
      this.utils.inputVal.next(this.myControl.value);
      this.router.navigate(['/search'])
    }
  }

  getRecentlySearched() {

    if (this.utils.getToken()) {
      this.sub.add(this.http.getRecentSearchedItems().subscribe((data: any) => {
        if (data.success) {
          this.recentlySearchList = data.searchedDetails;
          this.recentlySearchList.reverse();
        }
      }))
    }
  }

  categoryHandler(index: any, categoryData: any) {
    if (categoryData && categoryData.category && categoryData.category.toLowerCase() == 'e-shop') {
      this.navBarHandler(false);
      this.router.navigate(['shop-now']);
    }
    else if (categoryData && categoryData.category && categoryData.category.toLowerCase() == 'store locator') {
      this.navBarHandler(false);
      this.router.navigate(['store-locator']);
      this.analyticsService?.triggerStoreLocatorvisitEvent('click_store_locator_vist')

    }
    else {
      this.sub.add(this.utils.menuList.subscribe((data: any) => {
        this.utils.selectedCategory.landingPageGuid = data[index].landingPageGuid;
        this.utils.selectedCategory.activeFeatureIconFile = data[index].activeFeatureIconFile;
        this.utils.selectedCategory.inActiveFeatureIconFile = data[index].inActiveFeatureIconFile;
        this.utils.selectedCategory.featureAltTag = data[index].featureAltTag;
        this.utils.selectedCategory.category = data[index].category;
        this.utils.selectedCategory.categoryType = data[index].categoryType;
        this.utils.selectedSubCategory = data[index].brandSubCategoriesMenus;
      }))
    }
  }

  subCatHandler(categoryData: any, subCatData: any) {
    this.topMenuClickTrigger({ cat: (categoryData.category || ''), subcat: subCatData.subCategory, series: '' })
    this.navBarHandler(false);
  }

  minorSubCatHandler(subSubCatData: any) {
    let subSubCatTitle = this.utils.createNameForUrl(subSubCatData.name)
    return `/solar-application/${subSubCatTitle}`;
  }

  getSubCatRouteLink(subCatData: any) {
    let subCatTitle = this.utils.createNameForUrl(subCatData.subCategory)
    return `/sub-category/${subCatTitle}`
  }

  seriesNavHandler(categoryData: any, subCatData: any, seriesData: any) {
    this.topMenuClickTrigger({ cat: (categoryData.category || ''), subcat: subCatData.subCategory, series: seriesData.series });
    this.navBarHandler(false);

  }

  getSeriesRouteLink(catData: any, subCatData: any, seriesData: any) {
    return `/product-listing/${this.utils.createNameForUrl(catData.category)}/${this.utils.createNameForUrl(subCatData.subCategory)}/${this.utils.createNameForUrl(seriesData.series)}`
  }

  topMenuClickTrigger(data: any) {
    const gtmData = {
      eventName: "Top Menu Clicked",
      eventData: {
        'Category Clicked': data.cat,
        'Sub-Category Clicked': data.subcat,
        'Series Clicked': data.series
      }
    };

    this.analyticsService.trackData(gtmData);
  }

  backBtnHandler() {
    this.utils.selectedCategory.landingPageGuid = '';
    this.utils.selectedCategory.activeFeatureIconFile = '';
    this.utils.selectedCategory.featureAltTag = '';
    this.utils.selectedCategory.inActiveFeatureIconFile = '';
    this.utils.selectedCategory.category = '';
    this.utils.selectedCategory.categoryType = '';
    this.utils.selectedSubCategory = [];
    this.utils.subCatOpenIndex = -1;
    this.process = 0;
  }

  resetAllNavBarNavigation() {
    this.backBtnHandler();
  }


  panelStateHandler(index: number, flag: boolean) {

    if (flag && this.utils.subCatOpenIndex == -1 && this.process == 0) {
      this.process++;
      this.utils.subCatOpenIndex = index;
    }

    else if (flag && this.process == 1 && this.utils.subCatOpenIndex != index) {
      this.utils.subCatOpenIndex = index;
    }

    else if (!flag && this.process == 1 && this.utils.subCatOpenIndex == index) {
      this.utils.subCatOpenIndex = -1;
      this.process = 0
    }
  }
  logout() {
    this.utils.showLoading();
    this.socialSignOut();
    if (this.sidenavOpen && this.utils.screenSizeObj.width < 768) {
      this.SigninService.logOut();
    }
    this.navBarHandler(false);
  }

  socialSignOut(): void {
    this.sub.add(this.authService.authState.subscribe((user) => {
      if (user) {
        this.authService.signOut();
      }
    }));
  }

  navigateToSignIn() {
    if (this.sidenav) { this.navBarHandler(false); }
    if (!this.SigninService.getIsAuth())
      this.router.navigate(['/sign-in'])
    else
      this.showDropDownList = true;
  }



  dropdownListHandler(value: any) {
    this.showDropDownList = false;
    if (value) {
      this.logout()
    }
  }

  categoryCLickHandler(categoryData: any) {
    this.topMenuClickTrigger({ cat: categoryData.category, subcat: '', series: '' })
    this.analyticsService?.triggerStoreLocatorvisitEvent('click_store_locator_vist')

    this.navBarHandler(false);
  }

  getCategoryRouteLink(categoryData: any) {
    let url = ''
    if (categoryData && categoryData.category && categoryData.category.toLowerCase() == 'e-shop') {
      url = '/shop-now';
    }
    else if (categoryData && categoryData.category && categoryData.category.toLowerCase() == 'store locator') {
      url = '/store-locator';
    }
    else {
      let catTitle = this.utils.createNameForUrl(categoryData.category);
      if (categoryData.categoryType && categoryData.categoryType.toLowerCase() == 'inbt') {
        url = `/category/energy-storage/${catTitle}`
      }
      else {
        url = `/category/solar/${catTitle}`
      }
    }
    return url;
  }

  checkWidth(array: any) {
    if (array.length == 1 || array.length == 2) {
      return "menu-md"
    }
    else {
      return "menu-lg"
    }
  }

  redirectToPath(link: any) {
    this.router.navigate([link]);
    this.navBarHandler(false);
  }

  trackCartViewed() {
    this.analyticsService?.triggerCartViewed();
  }
  ngOnDestroy(): void {

    this.sub.unsubscribe()
  }
}

